import "./App.css";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "./components/Layout";
import Login from "./pages/Login/Login";
import Registration from "./pages/Registartion";
import NotFound from "./pages/NotFound/NotFound";
import Orders from "./components/Ordres";
import Vehicles from "./pages/Vehicles/Vehicles";
import Staff from "./pages/Staff/Staff";
import Operation from "./pages/Operation/Operation";
import Services from "./pages/Services/Services";
import Clients from "./pages/Clients/Clients.jsx";
import Stock from "./pages/stock/Stock.jsx";
import Vendors from "./pages/stock/Vendors.jsx";
import Supplier from "./pages/stock/Supplier.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { IDProvider } from "./components/SharedModule/IdContext";
import { toast, ToastContainer } from "react-toastify";
// more imports...
import VanProfile from "./pages/Vehicles/VanProfile";
import OrderDetails from "./components/Modals/OrdersDetails";
import StaffVans from "./components/StaffVans";
import ActivityLog from "./components/ActivityLog";
import OrderDetailsUpdated from "./components/OrderDetailsUpdated";
import OrdersMap from "./components/OrdersMap";
import Activity from "./components/Activity";
import ServicesMainCard from "./pages/Services/Services_mainCard/ServicesMainCard.jsx";
import Authoriztion from "./pages/Authoriztion/Authoriztion.jsx";
import SupplierProfile from "./pages/stock/SupplierProfile.jsx";
import BarCode from "./pages/stock/BarCode.jsx";
import ClientComments from "./components/ClientComments.jsx";
import Member from "./pages/Operation/Member/Member.jsx";
import OffersPage from "./pages/Services/Services_mainCard/OffersPage.jsx";
import License from "./components/Modals/License";
import AddVanLicense from "./components/Modals/AddVanLicense.jsx";
import Batches from "./pages/stock/Batches.jsx";
import AddNewReward from "./components/Rewards/AddNewReward.jsx";
import VariationProfile from "./pages/stock/VariationProfile.jsx";
import ArrangeOrders from "./pages/ArrangeOrders.jsx";
import { SidebarProvider } from "./components/SidebarProvider.jsx";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import CheckBefore from "./components/CarCheck/CheckBefore.jsx";
import CheckAfter from "./components/CarCheck/CheckAfter.jsx";
import PointsTransaction from "./components/Rewards/PointsTransaction.jsx";
import Coupons from "./components/Rewards/Coupons.jsx";
import CreateNewCoupon from "./components/Rewards/CreateNewCoupon.jsx";
import Offers from "./pages/Offers/Offers.jsx";
import AddNewOffer from "./pages/Offers/AddNewOffer.jsx";
import Categories from "./pages/Categories/Categories.jsx";
import Brands from "./pages/Brands/Brands.jsx";
import BrandsProfile from "./pages/Brands/BrandsProfile.jsx";
import CategoryProfile from "./pages/Categories/CategoryProfile.jsx";
import BrandCategoryProfile from "./pages/Categories/BrandCategoryProfile.jsx";
import SubCategoryProfile from "./pages/Categories/SubCategoryProfile.jsx";
import Manufacturers from "./pages/Manufacturers/Manufacturers.jsx";
import ManufactureProfile from "./pages/Manufacturers/ManufactureProfile.jsx";
import OfferProfile from "./pages/Offers/OfferProfile.jsx";
import Templates from "./pages/Notification/Templates.jsx";
import TemplateProfile from "./pages/Notification/TemplateProfile.jsx";
import NotificationsDashboard from "./pages/Notification/NotificationsDashboard.jsx";
import AutomatedNotif from "./pages/Notification/AutomatedNotif.jsx";
import UserGroup from "./pages/Notification/UserGroup.jsx";
import NotificationCategories from "./pages/Notification/NotificationCategories.jsx";
import TargetingRules from "./pages/Notification/TargetingRules.jsx";
import NotificationCampaigns from "./pages/Notification/NotificationCampaigns.jsx";
import BasicRewards from "./components/Rewards/BasicRewards.jsx";
import CircuitBreakers from "./pages/Notification/CircuitBreakers.jsx";
import VehiclesCategories from "./pages/New Vehicles/VehiclesCategories.jsx";
import VehiclesBrandProfile from "./pages/New Vehicles/VehiclesBrandProfile";
import BrandVehicle from "./pages/New Vehicles/BrandVehicle.jsx";
import Tables from "./pages/Equipments/Tables.jsx";
import NewEQprofile from "./pages/Equipments/NewEQprofile.jsx";
import EqCard from "./pages/NewEquipment/EqCard.jsx";
import EQModals from "./pages/NewEquipment/EQModals.jsx";
import RequestedEquipment from "./pages/NewEquipment/RequestedEquipment.jsx";
import SubCtegoery from "./pages/NewEquipment/SubCtegoery.jsx";
import OnSitePrices from "./pages/Services/OnSitePrices.jsx";
import Maintenance from "./components/User Requests/Maintenance.jsx";
import OtherServices from "./components/User Requests/OtherServices.jsx";
import Bundles from "./components/User Requests/Bundles.jsx";
import Otp from "./components/Otp/Otp.jsx";
import Home from "./pages/DriverFlow/Home.jsx";
import DayOrders from "./pages/DriverFlow/DayOrders.jsx";
import OrderServices from "./pages/DriverFlow/OrderServices.jsx";
import MaterialsForOrders from "./pages/DriverFlow/MaterialsForOrders.jsx";
import Servicess from "./pages/DriverFlow/Servicess.jsx";
import FinishOrderConfirmation from "./pages/DriverFlow/FinishOrderConfirmation.jsx";
import ServicesNotes from "./pages/DriverFlow/ServicesNotes.jsx";
// import CheckingTools from "./pages/DriverFlow/CheckingTools.jsx";
import Test from "./components/Test.jsx";
import TestVideo from "./components/TestVideo.jsx";
import Notes from "./pages/Staff/Notes.jsx";
import StaffProfile from "./pages/Staff/StaffProfile.jsx";
import Expenses from "./pages/Staff/Expenses.jsx";
import Sos from "./pages/DriverFlow/Sos.jsx";
import TripsHistory from "./pages/DriverFlow/TripsHistory.jsx";
import DriverProfile from "./pages/DriverFlow/DriverProfile.jsx";
import CheckingCars from "./pages/DriverFlow/CheckingCars.jsx";
import OrdersHistory from "./components/EngineerFlow/OrdersHistory.jsx";
import OrdersProductsCheck from "./components/EngineerFlow/OrdersProductsCheck.jsx";
import ConfirmProductsCheck from "./components/EngineerFlow/ConfirmProductsCheck.jsx";
import OrdersExecuting from "./components/EngineerFlow/OrdersExecuting.jsx";
import CheckingTools from "./components/EngineerFlow/CheckingTools.jsx";
import { useHorizontalScroll } from "./hooks/useHorizontalScroll.js";
import useActiveChecksPolling from "./hooks/useActiveChecksPolling.js";
import CheckOrderItems from "./components/EngineerFlow/CheckOrderItems.jsx";
import ImageBefore from "./components/EngineerFlow/ImageBefore.jsx";
import ImageAfter from "./components/EngineerFlow/ImageAfter.jsx";
import ConfirmPayment from "./components/EngineerFlow/ConfirmPayment.jsx";
import SosRequests from "./pages/Staff/SosRequests.jsx";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase.js";
import axios from "axios";
import AllNotificationsPage from "./components/NotificationPanel/AllNotificationsPage.jsx";
import HelpRequests from "./components/User Requests/HelpRequests.jsx";
import HelpRequestProfile from "./components/User Requests/HelpRequestProfile.jsx";
import Overview from "./pages/Incentives/Overview/Overview.jsx";
import AllIncentives from "./pages/Incentives/AllIncentives/AllIncentives.jsx";
import NewRequestAlert from "./components/NotificationPanel/NewRequestAlert.jsx";
import CreateIncentives from "./pages/Incentives/CreateIncentive.jsx";
import IncentivesCoupons from "./pages/Incentives/Coupons/IncentivesCoupons.jsx";
import { useDispatch } from "react-redux";
import { authActions } from "./redux/slices/authSlice.js"; 
import { initSessionSync } from "./redux/sessionSync.js"; 
import { useRef } from "react";
import ExecuteByService from "./components/EngineerFlow/ExecuteByService.jsx";
import OrderReviews from "./components/OrderReviews.jsx";
import Vouchers from "./pages/Incentives/Vouchers/Vouchers.jsx";
import VoucherDetails from "./pages/Incentives/VoucherDetails/VoucherDetails.jsx";
import PromoCodes from "./pages/Incentives/Promo Codes/PromoCodes.jsx";
import OffersIncentives from "./pages/Incentives/Offers/OffersIncentives.jsx";
import IncentivesBundles from "./pages/Incentives/Bundles/IncentivesBundles.jsx";
import Loyalty from "./pages/Incentives/Loyalty/Loyalty.jsx";
import Cashback from "./pages/Incentives/Cashback/Cashback.jsx";
import LoyaltyRewards from "./pages/Incentives/Loyalty/LoyaltyRewards.jsx";
import LoyaltyTiers from "./pages/Incentives/Loyalty/LoyaltyTiers.jsx";
import LoyaltyLogs from "./pages/Incentives/Loyalty/LoyaltyLogs.jsx";
import CouponDetails from "./pages/Incentives/CouponDetails/CouponDetails.jsx";
import PromoCodeDetails from "./pages/Incentives/Promo Codes/PromoCodeDetails/PromoCodeDetails.jsx";
import EditSavedAddress from "./components/SavedAddresses/EditSavedAddress.jsx";
import OfferDetails from "./pages/Incentives/Offers/OfferDetails/OfferDetails.jsx";
import BundleDetails from "./pages/Incentives/Bundles/BundlesDetails/BundlesDetails.jsx";
import CashbackDetails from "./pages/Incentives/Cashback/CashbackDetails/CashbackDetails.jsx";
import Referral from "./pages/Incentives/Referral/Referral.jsx";
import ClientProfile from "./pages/Clients/ClientProfile/ClientProfile.jsx";

function App() {

  const { user } = useSelector((state) => state.auth);

  const Token = user?.token;

  const location = useLocation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [checkingSession, setCheckingSession] = useState(!user);
  
  const initialPathRef = useRef(location.pathname + location.search);

  const cameInWithoutUserRef = useRef(!user);

  const { pathWithoutLayout } = useSelector((state) => state.auth);

  useEffect(() => {
    const { channel, requestSession } = initSessionSync({
      getSession: () => {
        const stored = sessionStorage.getItem("userInfo");
        return stored ? JSON.parse(stored) : null;
      },
      onSessionReceived: (session) => {
        if (session) {
          sessionStorage.setItem("userInfo", JSON.stringify(session));
          dispatch(authActions.login(session));
          if (cameInWithoutUserRef.current) {
            navigate(initialPathRef.current, { replace: true });
          }
        }
        setCheckingSession(false);
      },
    });

    const justLoggedOut = sessionStorage.getItem("loggedOut") === "true"; 

    if (!user && !justLoggedOut) { 
      requestSession();
      const timeout = setTimeout(() => setCheckingSession(false), 700);
      return () => {
        clearTimeout(timeout);
        channel?.close();
      };
    }

    setCheckingSession(false); 
    return () => channel?.close();
  }, []);

  useEffect(() => {
    if (checkingSession) return;
    if (!user && !pathWithoutLayout.includes(location.pathname)) {
      navigate("/login", { state: { from: location } });
    }
  }, [user, location, checkingSession]);

  const AdminRoles = ["super-admin", "admin", "supervisor", "agent", "outbound-agent"];

  const AgentRoles = [
    "follow-up",
    "provider",
    "outbound",
    "inbound",
    "order-manager",
    "engineer",
    "technician",
    "driver",
    "outbound-agent",
    "estbn-help-handler",
    "user",
    "agent  "
  ];

  const ifuserIsSupervisor =
    user?.operator?.roles?.length > 0
      ? user.operator.roles.some((e) => e.name === "supervisor")
      : user?.operator?.role === "supervisor";

  useHorizontalScroll();
  useActiveChecksPolling();

  // firbase effects

  const [alertTrigger, setAlertTrigger] = useState(null);

  useEffect(() => {
    console.log("🔍 Token value:", Token);
    console.log("🔍 User value:", user);
    if (!Token) return;
    const initNotifications = async () => {
      console.log("🚀 initNotifications started");
      const permission = await Notification.requestPermission();
      console.log("🔔 Permission:", permission);
      if (permission !== "granted") {
        console.log("❌ Permission denied");
        return;
      }
      let registration;
      try {
        registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        console.log("⚙️ SW registered:", registration);
      } catch (err) {
        console.error("❌ SW registration error:", err);
        return;
      }
      console.log("📡 Getting FCM token...");
      try {
        const token = await getToken(messaging, {
          vapidKey: "BA9VY8GXetTRAMTvTCfU_eBYu6IJE6OJIKrCe2eSV9RZsMpsfj793KcgHkNHjJyrV6l5_hsAmME2Edq85S9hJAk",
          serviceWorkerRegistration: registration,
        });
        console.log("🔥 FCM TOKEN:", token);
        let deviceId = sessionStorage.getItem("device_id");
        if (!deviceId) {
          deviceId = Math.random().toString(36).substring(2);
          sessionStorage.setItem("device_id", deviceId);
        }
        const formData = new FormData();
        formData.append("device_token", token);
        formData.append("device_type", "web");
        formData.append("device_id", deviceId);
        await axios.post(
          "https://estbn.com/EstbnNew/public/api/save-fcm-token",
          formData,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );
        console.log("✅ Token saved to backend");
      } catch (err) {
        console.error("❌ getToken error:", err);
      }
    };
    initNotifications();
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Foreground Message:", payload);
      const { title, body } = payload.notification;
      const data = payload.data;
      toast.info(
        <div>
          <strong>🔔 {title}</strong>
          <p style={{ margin: "4px 0 0", fontSize: "13px" }}>{body}</p>
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
        }
      );
      const key = mapNotificationToTrigger(data);
      if (key) {
        setAlertTrigger({
          key,
          id: payload.messageId || Date.now(),
        });
      }
    });
    return () => unsubscribe();
  }, [Token]);

  const mapNotificationToTrigger = (data) => {
    switch (data?.type) {
      case "portal_help_requested":
        return "helpRequests";
      case "portal_other_request_created":
        return "otherServices";
      case "portal_order_created":
        return "orders";
      default:
        if (data?.category_id) {
          return "maintenance";
        }
        return null;
    }
  };

  return (

    <SidebarProvider>
      <IDProvider>
        <NewRequestAlert trigger={alertTrigger} />
        <Layout>
          <Routes>
            <Route
              path="login"
              element={
                !user ? (
                  <Login />
                ) : checkingSession ? (
                  null
                ) : (
                  <Navigate
                    to={user?.user_type === "stuff" ? "/Home" : "/orders"}
                    replace
                  />
                )
              }
            />
            <Route
              path="registration"
              element={
                !user ? (
                  <Registration />
                ) : ifuserIsSupervisor ? (
                  <Navigate to="/orders" />
                ) : (
                  <Navigate to="/orders" />
                )
              }
            />
            <Route
              path="otp"
              element={<Otp />}
            />
            {/* driver routes */}
            <Route path="Home" element={<Home />} />
            <Route path="dayOrders" element={<DayOrders />} />
            <Route path="dayOrders/:id" element={<OrderServices />} />
            <Route path="Materials" element={<MaterialsForOrders />} />
            <Route path="engineerService" element={<Servicess />} />
            <Route path="OrderConfirmation" element={<FinishOrderConfirmation />} />
            <Route path="ServiceNotes" element={<ServicesNotes />} />
            <Route path="checkCar" element={<CheckingCars />} />
            <Route path="trips" element={<TripsHistory />} />
            <Route path="sos" element={<Sos />} />
            <Route path="profile" element={<DriverProfile />} />
            {/* engineer routes */}
            <Route path="ordersExecution" element={<OrdersExecuting />} />
            <Route path="ordersExecution/checkItems/:id" element={<CheckOrderItems />} />
            <Route path="ordersExecution/executeByService/:id/imageBefore" element={<ImageBefore />} />
            <Route path="ordersExecution/executeByService/:id/imageAfter" element={<ImageAfter />} />
            <Route path="ordersExecution/executeByService/:id/confirmPayment" element={<ConfirmPayment />} />
            <Route path="ordersHistory" element={<OrdersHistory />} />
            <Route path="ordersProductsCheck" element={<OrdersProductsCheck />} />
            <Route path="ordersProductsCheck/confirmCheck/:id" element={<ConfirmProductsCheck />} />
            <Route path="ordersExecution/:id" element={<OrdersExecuting />} />
            <Route path="ordersExecution/executeByService/:id" element={<ExecuteByService />} />
            <Route path="checkingtools" element={<CheckingTools />} />
            <Route path="/notifications" element={<AllNotificationsPage />} />
            {/* operation routes */}
            <Route element={<ProtectedRoute allowedRoles={[...AgentRoles, ...AdminRoles]} />}>
              <Route path="/" element={!ifuserIsSupervisor ? <Orders /> : <Navigate to="/orders" />} />
              <Route path="/notifications" element={<AllNotificationsPage />} />
              <Route path="orders" element={<Orders />} />
              <Route
                path="/saved-addresses/edit/:savedAddressId/:addressId"
                element={<EditSavedAddress />}
              />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="vehicles" element={<Vehicles />} />
              <Route path="vehicles/:id" element={<VanProfile />} />
              <Route path="ordersdetails" element={<OrderDetails />} />
              <Route path="staff-vans" element={<StaffVans />} />
              <Route path="ActivityLog" element={<ActivityLog />} />
              <Route path="OrderDetailsUpdated" element={<OrderDetailsUpdated />} />
              <Route path="orders/:id" element={<OrderDetailsUpdated />} />
              <Route path="Map" element={<OrdersMap />} />
              <Route path="Activity" element={<Activity />} />
              <Route path="Activity/:id" element={<Activity />} />
              <Route path="arrangeorders" element={<ArrangeOrders />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["super-admin", "admin", "supervisor", "outbound-agent"]} />}>
              <Route path="permissions" element={<Authoriztion />} />
              <Route path="staff" element={<Staff />} />
              <Route path="staff/:id" element={<StaffProfile />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="notes" element={<Notes />} />
              <Route path="sosRequests" element={<SosRequests />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="maintenance/:id" element={<Maintenance />} />
              <Route path="requests" element={<OtherServices />} />
              <Route path="requests/:id" element={<OtherServices />} />
              <Route path="helpRequests" element={<HelpRequests />} />
              <Route path="helpRequests/:id" element={<HelpRequestProfile />} />
              <Route path="bundles" element={<Bundles />} />
              <Route path="other" element={<Maintenance />} />
              <Route path="operation" element={<Operation />} />
              <Route path="operation/:id" element={<Member />} />
              <Route path="services" element={<Services />} />
              <Route path="services/:id" element={<ServicesMainCard />} />
              <Route path="services/:id/Pervisit" element={<OnSitePrices />} />
              <Route path="services/:id/offers" element={<OffersPage />} />
              <Route path="equipments" element={<EqCard />} />
              <Route path="EQmodal" element={<EQModals />} />
              <Route path="subcategory" element={<SubCtegoery />} />
              <Route path="requested" element={<RequestedEquipment />} />
              <Route path="AllEquipments" element={<Tables />} />
              <Route path="AllEquipments/:eqId" element={<NewEQprofile />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientProfile />} />
              <Route path="stock" element={<Stock />} />
              <Route path="stock/:productId" element={<VariationProfile />} />
              <Route path="stock/:productId/batches" element={<Batches />} />
              <Route path="stock/:productId/batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="stock/vendors" element={<Vendors />} />
              <Route path="stock/vendors/supplier" element={<Supplier />} />
              <Route path="stock/vendors/supplier/:id" element={<Supplier />} />
              <Route path="stock/vendors/:id" element={<SupplierProfile />} />
              <Route path="comments" element={<ClientComments />} />
              <Route path="comments/:id" element={<ClientComments />} />
              <Route path="checkBefore/:id" element={<CheckBefore />} />
              <Route path="checkAfter/:id" element={<CheckAfter />} />
              <Route path="comments/:id" element={<ClientComments />} />
              <Route path="ordReviews/:id" element={<OrderReviews />} />
              <Route path="License" element={<License />} />
              <Route path="AddVanLicense" element={<AddVanLicense />} />
              <Route path="NotifcationsDashboard" element={<NotificationsDashboard />} />
              <Route path="AutomatedNotification" element={<AutomatedNotif />} />
              <Route path="Templates" element={<Templates />} />
              <Route path="Templates/:id" element={<TemplateProfile />} />
              <Route path="Usergroup" element={<UserGroup />} />
              <Route path="Notification Categories" element={<NotificationCategories />} />
              <Route path="targetingRules" element={<TargetingRules />} />
              <Route path="notificationCampaigns" element={<NotificationCampaigns />} />
              <Route path="CircuitBreakers" element={<CircuitBreakers />} />
              <Route path="Rewards" element={<BasicRewards />} />
              <Route path="AddNewReward" element={<AddNewReward />} />
              <Route path="pointsTransaction" element={<PointsTransaction />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="coupons/:id" element={<CreateNewCoupon />} />
              <Route path="coupons/createNewCoupon" element={<CreateNewCoupon />} />
              <Route path="offers" element={<Offers />} />
              <Route path="offers/AddNewOffer" element={<AddNewOffer />} />
              <Route path="offers/edit/:id" element={<AddNewOffer />} />
              <Route path="offers/:id" element={<OfferProfile />} />
              <Route path="Categories" element={<Categories />} />
              <Route path="Categories/:id" element={<CategoryProfile />} />
              <Route path="Categories/:id/subcategory/:subCatId" element={<SubCategoryProfile />} />
              <Route path="Categories/:id/brand/:brandId" element={<BrandCategoryProfile />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId" element={<BrandCategoryProfile />} />
              <Route path="Categories/:id/brand/:brandId/Products/:productId" element={<VariationProfile />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId/Products/:productId" element={<VariationProfile />} />
              <Route path="Categories/:id/brand/:brandId/Products/:productId/Batches" element={<Batches />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId/Products/:productId/Batches" element={<Batches />} />
              <Route path="Categories/:id/brand/:brandId/Products/:productId/Batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="Categories/:id/subcategory/:subCatId/brand/:brandId/Products/:productId/Batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="Brands" element={<Brands />} />
              <Route path="Brands/:id" element={<BrandsProfile />} />
              <Route path="Brands/:id/Products/:productId" element={<VariationProfile />} />
              <Route path="Brands/:id/Products/:productId/Batches" element={<Batches />} />
              <Route path="Brands/:id/Products/:productId/Batches/:batchId/BarCode" element={<BarCode />} />
              <Route path="manufacturers" element={<Manufacturers />} />
              <Route path="manufacturers/manufactureProfile/:id" element={<ManufactureProfile />} />
              <Route path="vehiclesCategories" element={<VehiclesCategories />} />
              <Route path="vehiclesCategories/:categoryId" element={<BrandVehicle />} />
              <Route path="vehiclesCategories/:categoryId/vehiclesBrand/:brandId" element={<VehiclesBrandProfile />} />
              <Route path="/overView" element={<Overview />} />
              <Route path="/incentives" element={<AllIncentives />} />
              <Route path="/image" element={<Test />} />
              <Route path="/video" element={<TestVideo />} />
              <Route path="/incentives/createIncentive" element={<CreateIncentives />} />
              <Route path="/incentivesCoupons" element={<IncentivesCoupons />} />
              <Route path="/couponDetails" element={<CouponDetails />} />
              <Route path="/vouchers" element={<Vouchers />} />
              <Route path="/vouchers/:id" element={<VoucherDetails />} />
              <Route path="/promocodes" element={<PromoCodes />} />
              <Route path="/promocodeDetails" element={<PromoCodeDetails />} />
              <Route path="/offersIncentives" element={<OffersIncentives />} />
              <Route path="/offerDetails" element={<OfferDetails />} />
              <Route path="/incentives/bundles" element={<IncentivesBundles />} />
              <Route path="/bundleDetails" element={<BundleDetails />} />
              <Route path="/loyalty" element={<Loyalty />} />
              <Route path="/loyaltyRewards" element={<LoyaltyRewards />} />
              <Route path="/loyaltyTiers" element={<LoyaltyTiers />} />
              <Route path="/loyaltyLogs" element={<LoyaltyLogs />} />
              <Route path="/cashback" element={<Cashback />} />
              <Route path="/cashbackDetails" element={<CashbackDetails />} />
              <Route path="/referral" element={<Referral />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <ToastContainer />
      </IDProvider>
    </SidebarProvider>
  );
}

export default App;
